import { AGSWin } from "ags/integration/schema/ags-spin-response-schema";
import Record from "slotworks/model/gameplay/records/record";
import LineResult from "slotworks/model/gameplay/records/results/line-result";
import Result from "slotworks/model/gameplay/records/results/result";
import slotDefinition from "slotworks/model/slot-definition";
import Point from "slotworks/utils/geom/point";
import { AGSResultBuilder } from "./abstract-ags-result-builder";

export class LineResultBuilder extends AGSResultBuilder {
    public filter(response: AGSWin): boolean {
        return response.lineNumber !== undefined;
    }

    public build(record: Record, response: AGSWin): Result[] {
        const symbolDefinition = slotDefinition.symbolDefinitions[response.symbolId];

        const result = new LineResult();
        result.symbolType = symbolDefinition.id;
        result.cashWon = response.winAmount;
        result.line = response.lineNumber;
        result.positions = response.winningSymbolsPositions.map((position) => new Point(position[0], position[1]));
        result.matches = response.winningSymbolsPositions.length;

        const freespinResults = this.processFreespinData(record, response, result);

        return [result, ...freespinResults];
    }
}

export default new LineResultBuilder();
